import React from 'react';
import { ShieldCheck, Sparkles, CarFront, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

const About = () => {
  const features = [
    {
      icon: Sparkles,
      title: 'Premium Products',
      description: 'Professional-grade cleaning products for superior, lasting results.',
    },
    {
      icon: ShieldCheck,
      title: 'Professional Service',
      description: 'Trained technicians dedicated to delivering showroom-quality finishes.',
    },
    {
      icon: CarFront,
      title: 'Convenient Mobile Valeting',
      description: 'We come to your home or workplace across Sheffield and surrounding areas.',
    },
  ];

  return (
    <section className="section section-dark">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <img
              src="/assets/images/about/about.webp"
              alt="Professional mobile car valeting in Sheffield"
              loading="lazy"
              onError={(e) => {
                e.target.src = '/assets/images/work/work-1.jpeg';
              }}
            />
          </div>

          <div>
            <div className="eyebrow">About ARA</div>
            <h2>
              Professional Car Care,
              <span className="text-gold"> Brought To You.</span>
            </h2>
            <p style={{ marginBottom: '2rem' }}>
              ARA Mobile Valeting delivers premium car care directly to your doorstep.
              Combining professional-grade products, expert techniques, and unmatched
              convenience — we bring the showroom shine to you.
            </p>

            <div className="about-features">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="about-feature">
                    <div className="about-feature-icon">
                      <Icon size={22} />
                    </div>
                    <div>
                      <div className="about-feature-title">{feature.title}</div>
                      <p className="about-feature-desc">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ marginTop: '2rem' }}>
              <Link to="/about">
                <Button variant="outline">
                  Learn More
                  <ArrowRight size={18} />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;